import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-poi text-primary icon-in-text",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "form-control__arrow" }, null, -1)
const _hoisted_7 = { class: "text-truncate" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-calendar text-primary icon-in-text",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "form-control__arrow" }, null, -1)
const _hoisted_10 = { class: "text-truncate" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-adult text-primary icon-in-text",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "form-control__arrow" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "btn btn-cta booking-widget__search-button" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon icon-arrow-right",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_14 = { class: "h1 text-center mb-3" }
const _hoisted_15 = { class: "booking-widget__container-sm" }
const _hoisted_16 = { class: "h1 text-center mb-3" }
const _hoisted_17 = { class: "booking-widget__container-sm" }
const _hoisted_18 = {
  key: 0,
  class: "strong text-center mb-3"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-poi me-2 booking-panel__title-icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_20 = { class: "booking-widget__container" }
const _hoisted_21 = { class: "h1 text-center mb-3" }
const _hoisted_22 = { class: "booking-widget__container-sm" }
const _hoisted_23 = {
  key: 0,
  class: "strong text-center mb-3"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-poi me-2 booking-panel__title-icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_25 = { class: "booking-widget__container-sm" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-calendar me-2 booking-panel__title-icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "d-block"
}
const _hoisted_29 = {
  key: 1,
  class: "d-block"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "booking-widget__container-sm" }
const _hoisted_32 = ["action", "target"]
const _hoisted_33 = ["value"]
const _hoisted_34 = ["value"]
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = ["value"]
const _hoisted_38 = ["value"]

import Overlay from "../components/overlay/Overlay.vue";
    import Autosuggest from "../components/Autosuggest.vue";
    import CalendarView from "../components/CalendarView.vue";
    import PeopleView from "../components/PeopleView.vue";
    import {ref, onBeforeMount, watch} from 'vue';
    import {useBookingDataStore} from "../stores/BookingDataStore";
    import {storeToRefs} from 'pinia';
    import {useMediaQuery} from '@vueuse/core';
    import axios from "axios";
    import {trackSearch} from "../utils/utils";
    import {dateToISOString, localDateToUTCDate} from "../../libs/@elements/date-utils";
    import {trans as translate} from '../plugins/translate';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BookingWidget',
  props: {
        initialState: {
            type: Object,
            required: false,
            default: null
        },
        autocompleteRemoteUrl: {
            type: String,
            required: false,
            default: null
        },
        translations: {
            required: false,
            //type: Object,
            //default: {}
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        sessionCheckUrl: {
            type: String,
            required: false,
        },
        eventTracking: {
            type: Boolean,
            required: false,
            default: false
        },
        forceNewWindow: {
            type: Boolean,
            required: false,
            default: false
        }
    },
  setup(__props) {

const props = __props;

    const bookingDataStore = useBookingDataStore();

    const {startDate, endDate, adults, children, childrenAges} = storeToRefs(bookingDataStore);

    const showErrors = ref(false);
    const errorText = ref('');

    

    // const currentStep = ref<number>(0);
    const stepViews = ref(['location', 'calendar', 'people']);

    const isMobile = useMediaQuery('(max-width: 767px)');

    const changeStep = (newStep: number) => {
        // when the user confirms the date
        if (stepViews.value[bookingDataStore.currentStep] === 'calendar' && stepViews.value[newStep] === 'people') {
            bookingDataStore.dateConfirmed = true;
        }
        // user selects only one date (startDate) and clicks next
        if (stepViews.value[bookingDataStore.currentStep] === 'calendar' && !endDate.value) {
            // set endDate equal to startDate
            endDate.value = startDate.value;
        }
        // showErrors.value = false;
        bookingDataStore.currentStep = newStep;
    }

    const handleNextClick = () => {
        if (!bookingDataStore.nextButtonDisabled) {
            changeStep(bookingDataStore.currentStep + 1)
        } else {
            showStepError();
        }
    }

    const handleMainFormSubmit = (evt) => {
        if (!bookingDataStore.nextButtonDisabled) {
            bookingDataStore.eventTracking && trackSearch( bookingDataStore.selectedLocation.location.title, 'submit');
        } else {
            showStepError();
            evt.preventDefault();
        }

    }

    const showStepError = () => {
        showErrors.value = true;
        console.log('bookingDataStore.selectedLocation.dateValidationError', bookingDataStore.selectedLocation.dateValidationError);
        if (!bookingDataStore.selectedLocation.location) {
            errorText.value = translate('rent_site.location.booking-widget.error.location');
        } else if(bookingDataStore.selectedLocation.dateValidationError) {
            errorText.value = translate(bookingDataStore.selectedLocation.dateValidationError);
        } else if((adults.value + children.value) <= 0) {
            errorText.value = translate('rent_site.location.booking-widget.error.persons');
        }
    }

    // this watcher checks if the error message should be hidden again, after it has been shown by showStepError()
    watch(() => bookingDataStore.nextButtonDisabled, (newValue) => {
        if (newValue === false) {
            showErrors.value = false;
            errorText.value = '';
        }
    });

    // set the step that is shown when the widget is opened
    const setStepToShow = () => {
        if (bookingDataStore.dateConfirmed) {
            // start with people selection
            bookingDataStore.currentStep = 2;
        } else if (bookingDataStore.locationPredefined || bookingDataStore.selectedLocation.location) {
            // start with date selection
            bookingDataStore.currentStep = 1;
        } else {
            // start with location selection
            bookingDataStore.currentStep = 0;
        }
    }

    const onSelectLocation = async (location) => {
        bookingDataStore.selectedLocation.location = location;
        bookingDataStore.selectedLocation.formAction = location?.actions?.search;

        // we need a loading indicator here
        await bookingDataStore.requestLocationDetails(location?.actions?.season);
        // change state after date has been set, so the datepicker shows the correct initial month
        changeStep(1);
    }

    const formTarget = ref(null);
    onBeforeMount(() => {
        // set initial state
        if (props.initialState) {
            // let initialState = JSON.parse(props.initialState);
            bookingDataStore.$patch(props.initialState);
            bookingDataStore.prefillDates();
        }

        bookingDataStore.eventTracking = props.eventTracking;

        if (props.forceNewWindow) {
            // fore new window on submit (landing-pages)
            formTarget.value = '_blank';
        } else
        if (props.sessionCheckUrl) {
            // do session check for iframe
            return axios.get(props.sessionCheckUrl)
                .then((response) => {
                    // if the session is available, persistent will be true
                    // if session is not available, change form target to _blank
                    if (response.data.persistent !== true) {
                        formTarget.value = '_blank';
                    }
                })
                .catch((error) => {
                    console.error(error);
                });

        }

    })




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Overlay, {
    nextButtonDisabled: _unref(bookingDataStore).nextButtonDisabled,
    loading: _unref(bookingDataStore).loading,
    title: __props.title,
    bodyModifier: showErrors.value ? 'fullscreen-modal__body--has-error' : ''
  }, {
    button: _withCtx(({ show }) => [
      (_unref(bookingDataStore).reducedVersion)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn js-booking-widget__btn btn-primary btn-md",
            onClick: () => {setStepToShow(); show();}
          }, _toDisplayString(_ctx.$translate('rent_site.location.booking-widget.reservation-btn')), 9, _hoisted_1))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "btn-no-styling input-group",
            onClick: () => {setStepToShow(); show();}
          }, [
            (!_unref(isMobile) || _unref(isMobile) && !_unref(bookingDataStore).selectedLocation.location?.title)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "form-control form-control--fake d-md-block",
                  title: _unref(bookingDataStore).selectedLocation.location?.title
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    (_unref(bookingDataStore).selectedLocation.location?.title)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(bookingDataStore).selectedLocation.location.title), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$translate('rent_site.location.booking-widget.location.label')), 1)
                        ], 64))
                  ]),
                  _hoisted_6
                ], 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["form-control form-control--fake d-md-block", {'d-none form-control--fake-disabled': _unref(bookingDataStore).dateConfirmed || !_unref(bookingDataStore).selectedLocation.location?.title}])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                ((_unref(bookingDataStore).dateConfirmed || _unref(bookingDataStore).showDate) && (_unref(startDate) || _unref(endDate)))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(startDate))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(bookingDataStore).formattedStartDate), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_unref(endDate))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" – " + _toDisplayString(_unref(bookingDataStore).formattedEndDate), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$translate('rent_site.location.booking-widget.rental-period.label')), 1)
                    ], 64))
              ]),
              _hoisted_9
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["form-control form-control--fake d-md-block", {'d-none form-control--fake-disabled': !_unref(bookingDataStore).dateConfirmed || !_unref(bookingDataStore).selectedLocation.location?.title}])
            }, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                (_unref(bookingDataStore).showPersonAmount && (_unref(bookingDataStore).adults || _unref(bookingDataStore).children))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$translateChoice('rent_site.location.booking-widget.persons.person-amount', _unref(bookingDataStore).adults + _unref(bookingDataStore).children )), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$translate('rent_site.location.booking-widget.persons.label')), 1)
                    ], 64))
              ]),
              _hoisted_12
            ], 2),
            _hoisted_13
          ], 8, _hoisted_2))
    ]),
    content: _withCtx(() => [
      (stepViews.value[_unref(bookingDataStore).currentStep] === 'location')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$translate('rent_site.location.booking-widget.location.heading')), 1),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(Autosuggest, {
                onSelectLocation: onSelectLocation,
                baseUri: __props.autocompleteRemoteUrl
              }, null, 8, ["baseUri"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (stepViews.value[_unref(bookingDataStore).currentStep] === 'calendar')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$translate('rent_site.location.booking-widget.rental-period.heading')), 1),
            _createElementVNode("div", _hoisted_17, [
              (_unref(bookingDataStore).locationPredefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(bookingDataStore).selectedLocation.location.title), 1))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "booking-panel booking-panel--previous-step mb20 cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(bookingDataStore).currentStep = 0))
                  }, [
                    _hoisted_19,
                    _createTextVNode(_toDisplayString(_unref(bookingDataStore).selectedLocation.location.title), 1)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(CalendarView, {
                availableRanges: _unref(bookingDataStore).selectedLocation.availableRanges,
                closedDates: _unref(bookingDataStore).selectedLocation.closedDates,
                min: _unref(bookingDataStore).selectedLocation.minDate,
                max: _unref(bookingDataStore).selectedLocation.maxDate
              }, null, 8, ["availableRanges", "closedDates", "min", "max"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (stepViews.value[_unref(bookingDataStore).currentStep] === 'people')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$translate('rent_site.location.booking-widget.persons.heading')), 1),
            _createElementVNode("div", _hoisted_22, [
              (_unref(bookingDataStore).locationPredefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(bookingDataStore).selectedLocation.location.title), 1))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "booking-panel booking-panel--previous-step mb20 cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(bookingDataStore).currentStep = 0))
                  }, [
                    _hoisted_24,
                    _createTextVNode(_toDisplayString(_unref(bookingDataStore).selectedLocation.location.title), 1)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", {
                class: "booking-panel booking-panel--previous-step mb20 cursor-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(bookingDataStore).currentStep = 1))
              }, [
                _hoisted_26,
                (_unref(startDate) || _unref(endDate))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                      (_unref(startDate))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$translate('rent_site.location.rental-period.pickup-date')) + " " + _toDisplayString(_unref(bookingDataStore).formattedStartDate), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(),
                      (_unref(endDate))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$translate('rent_site.location.rental-period.return-date')) + " " + _toDisplayString(_unref(bookingDataStore).formattedEndDate), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$translate('rent_site.location.booking-widget.rental-period.label')), 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(PeopleView)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["booking-widget__error font-medium", [{'show': showErrors.value}]])
      }, _toDisplayString(errorText.value), 3),
      (_unref(bookingDataStore).currentStep === stepViews.value.length - 1)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            action: _unref(bookingDataStore).selectedLocation.formAction,
            method: "POST",
            target: formTarget.value,
            onSubmit: handleMainFormSubmit
          }, [
            _createElementVNode("input", {
              type: "hidden",
              name: "q",
              value: _unref(bookingDataStore).selectedLocation.location.title
            }, null, 8, _hoisted_33),
            _createElementVNode("input", {
              type: "hidden",
              name: "from",
              value: _unref(dateToISOString)(_unref(localDateToUTCDate)(_unref(startDate)), false)
            }, null, 8, _hoisted_34),
            _createElementVNode("input", {
              type: "hidden",
              name: "till",
              value: _unref(dateToISOString)(_unref(localDateToUTCDate)(_unref(endDate)), false)
            }, null, 8, _hoisted_35),
            _createElementVNode("input", {
              type: "hidden",
              name: "adultCount",
              value: _unref(adults)
            }, null, 8, _hoisted_36),
            _createElementVNode("input", {
              type: "hidden",
              name: "childCount",
              value: _unref(children)
            }, null, 8, _hoisted_37),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(childrenAges), (childAge) => {
              return (_openBlock(), _createElementBlock("input", {
                type: "hidden",
                name: "childAge[]",
                value: childAge
              }, null, 8, _hoisted_38))
            }), 256)),
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-cta fullscreen-modal__submit btn--show-disabled-state", _unref(bookingDataStore).nextButtonDisabled ? 'disabled' : ''])
            }, _toDisplayString(_ctx.$translate('rent_site.location.booking-widget.cta-btn')), 3)
          ], 40, _hoisted_32))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass(["btn btn-primary fullscreen-modal__submit btn--show-disabled-state", _unref(bookingDataStore).nextButtonDisabled ? 'disabled' : '']),
            onClick: handleNextClick
          }, _toDisplayString(_ctx.$translate('rent_site.location.booking-widget.next-btn')), 3))
    ]),
    _: 1
  }, 8, ["nextButtonDisabled", "loading", "title", "bodyModifier"]))
}
}

})